import HoverButton from './HoverButton';
import { jsx as _jsx } from "react/jsx-runtime";
const RectangularButton = props => {
  return /*#__PURE__*/_jsx(HoverButton, Object.assign({}, props, {
    borderRadius: "0px"
  }));
};
export default RectangularButton;